import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routing/Routes";
import "semantic-ui-css/semantic.min.css";

ReactDOM.render(<Routes></Routes>, document.getElementById("root"));
